import {
  APP_ENDPOINT as _APP_ENDPOINT,
  APP_POSTHOG_API_KEY as _APP_POSTHOG_API_KEY,
  ENVIRONMENT as _ENVIRONMENT,
  LARAVEL_INSTALLABLES_ENDPOINT as _LARAVEL_INSTALLABLES_ENDPOINT,
  PLATFORM_ENDPOINT as _PLATFORM_ENDPOINT,
  SOCIAL_MEDIA_ENDPOINT as _SOCIAL_MEDIA_ENDPOINT,
} from "./secrets";

const removeTrailingSlash = (value: string): string =>
  value.replace(/\/+$/, "");

export const ENVIRONMENT = _ENVIRONMENT ?? "";
export const PLATFORM_ENDPOINT = removeTrailingSlash(_PLATFORM_ENDPOINT ?? "");
export const APP_ENDPOINT = removeTrailingSlash(_APP_ENDPOINT ?? "");
export const SOCIAL_MEDIA_ENDPOINT = removeTrailingSlash(
  _SOCIAL_MEDIA_ENDPOINT ?? "",
);
export const LARAVEL_INSTALLABLES_ENDPOINT = removeTrailingSlash(
  _LARAVEL_INSTALLABLES_ENDPOINT ?? "",
);
export const POSTHOG_API_KEY = _APP_POSTHOG_API_KEY ?? "";

export const VESTABOARD_SDK_OPTIONS = {
  platformApiUrl: PLATFORM_ENDPOINT,
  installableApiUrl: LARAVEL_INSTALLABLES_ENDPOINT,
};

export const appInstallableSubscriptionUrl = (
  boardId: string,
  subscriptionId: string,
): string =>
  APP_ENDPOINT
    ? `${APP_ENDPOINT}/board/${boardId}/installables/subscription/${subscriptionId}`
    : "";
